<template>
  <div class="__ListCrossTag">
    <ListWrapper
      :data="crossTagResources"
      :filter-keys="['mainTagKey', 'mainTagValue', 'account_id']"
      :filter-placeholder="$t('Search resource')"
      :loading="loading"
    >
      <!--Header Actions-->
      <template v-slot:actions>
        <DropdownMenu
          :options="actionMenuOptions"
          position="bottom right"
          @click="handleClickAction"
          v-if="$can('DownloadBulk') && $display('usage_report_download')"
        >
          <template v-slot:activator>
            <CButton icon="save_alt" flat round />
          </template>
        </DropdownMenu>
      </template>

      <!--Body-->
      <template v-slot:body="slotProps">
        <ListItem
          v-for="item in slotProps.data"
          :badges="badges(item.multipleTags)"
          :key="item.id"
          :active="selectedId === item.id"
          :description="`ID: ${item.account_id}`"
          @click="handleClick(item)"
        >
          <div>
            <div class="label">
              {{ $t('Tag key') }}
            </div>
            <div class="value">
              <CTooltip :message="item.mainTagKey" :delay="500">
                {{ item.mainTagKey }}
              </CTooltip>
            </div>
          </div>

          <div>
            <div class="label">
              {{ $t('Tag value') }}
            </div>
            <div class="value">
              <CTooltip :message="item.mainTagValue" :delay="500">
                {{ item.mainTagValue }}
              </CTooltip>
            </div>
          </div>
          <div class="label">ID: {{ item.account_id }}</div>
        </ListItem>
      </template>
    </ListWrapper>
    <TagDialogDownloadBulkCsv v-model="visibleBulkDownloadModal" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import CTooltip from '@/components/uikit/CTooltip';
import ListWrapper from '@/pages/UsageReport/SideList/ListWrapper';
import ListItem from '@/pages/UsageReport/SideList/ListItem';
import DropdownMenu from '@/components/DropdownMenu';
import CButton from '@/components/uikit/CButton';
import TagDialogDownloadBulkCsv from '@/pages/UsageReport/SideList/ListCrossTagDialogDownloadBulkCsv';

const messages = {
  messages: {
    en: {
      Resource: 'Resource',
      'Search resource': 'Search resource',
      MultipleTags: 'MultipleTags',
      'Tag key': 'Tag key',
      'Tag value': 'Tag value',
    },
    ja: {
      Resource: 'リソース',
      'Search resource': 'リソースを検索',
      MultipleTags: '複数のタグ',
      'Tag key': 'タグ　キー',
      'Tag value': 'タグ　バリュー',
    },
  },
};

export default {
  name: 'ListCrossTag',
  i18n: messages,
  components: { CTooltip, ListWrapper, ListItem, DropdownMenu, TagDialogDownloadBulkCsv, CButton },
  computed: {
    ...mapState('crossTags', {
      loading: state => state.crossTags.loading,
    }),

    ...mapGetters('crossTags', {
      crossTagResources: 'getCrossTags',
    }),

    ...mapState('usageReports', {
      selectedId: state => state.id,
    }),
  },
  data() {
    return {
      visibleBulkDownloadModal: false,
      actionMenuOptions: [
        {
          label: this.$t('Report bulk download'),
          actionType: 'bulkDL',
          separate: false,
          icon: null,
        },
      ],
    };
  },
  methods: {
    ...mapMutations('crossTags', {
      updateSelectedId: 'updateSelectedId',
    }),

    badges(multipleTags) {
      if (multipleTags) {
        return [
          {
            type: 'primary',
            value: this.$t('MultipleTags'),
          },
        ];
      }
      return [];
    },

    handleClick(item) {
      this.updateSelectedId(item.id);
      this.$emit('click', item.id);
    },

    handleClickAction(actionType) {
      if (actionType === 'bulkDL') {
        this.visibleBulkDownloadModal = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.__ListCrossTag {
  .name {
    font-weight: $font-weight-bold;
    margin-bottom: $margin-xxs;
  }

  .label {
    width: 100%;
    font-size: $font-size-sm;
    color: $neutral-secondary-color;
  }

  .value {
    width: 100%;
    font-weight: $font-weight-bold;
    font-size: $font-size-md;
  }
}
</style>
